import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./ContactForm.css";

export default function ContactForm() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  function handleChange(e) {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  }

  function handleSend(e) {
    // Let FormSubmit receive the POST request
    // BUT we immediately redirect before their page loads
    alert("Message Sent!");

    // Short delay ensures the POST request is sent
    setTimeout(() => {
      navigate("/indexpage");
    }, 300);
  }

  return (
    <div className="contact-container">
      <h2>Contact Me</h2>
      <p>Have a question or want to connect? Send me a message.</p>

      <form
        action="https://formsubmit.co/joeitguy@gmail.com"
        method="POST"
        onSubmit={handleSend}
        className="contact-form"
        target="hidden_iframe"   // ⭐ prevents FormSubmit page from ever showing
      >
        {/* Hidden iframe to suppress FormSubmit redirect */}
        <iframe name="hidden_iframe" style={{ display: "none" }}></iframe>

        <input type="hidden" name="_captcha" value="false" />
        <input type="hidden" name="_subject" value="New message from your resume site!" />
        <input type="hidden" name="_template" value="table" />

        <label>Name *</label>
        <input 
          type="text" 
          name="name" 
          required 
          value={formData.name} 
          onChange={handleChange}
        />

        <label>Email *</label>
        <input 
          type="email" 
          name="email" 
          required 
          value={formData.email} 
          onChange={handleChange}
        />

        <label>Phone</label>
        <input 
          type="text" 
          name="phone" 
          value={formData.phone} 
          onChange={handleChange}
        />

        <label>Message</label>
        <textarea 
          name="message" 
          rows="5"
          value={formData.message}
          onChange={handleChange}
        />

        <button type="submit" className="send-btn">
          Send Message
        </button>
      </form>
    </div>
  );
}


